"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserNameSchema = void 0;
const zod_1 = require("zod");
const USER_NAME_WORD_PATTERN = /^\p{L}+(?:-\p{L}+)*$/u;
function isValidUserNameWord(word) {
    return USER_NAME_WORD_PATTERN.test(word);
}
exports.UserNameSchema = zod_1.z
    .string()
    .transform((value) => value.normalize('NFC').trim().replace(/\s+/g, ' '))
    .refine((value) => value.length > 0, 'Name must not be empty')
    .refine((value) => value.split(' ').every(isValidUserNameWord), 'Name may only contain letters and hyphens');
//# sourceMappingURL=userName.js.map